import * as types from './mutations_type.js'
import Vue from 'vue'

export const state = {
	roomCode: '',
	device: null,
	character: [
		{
			className: 'officeLady',
			name: 'OL',
			dialogLine1: '哎呀~',
			dialogLine2: '真是小確幸',
			selectSize: {
				width: 196,
				height: 310
			},
			avatarSize: [
				{
					width: 202,
					height: 296
				},
				{
					width: 168,
					height: 302
				},
				{
					width: 134,
					height: 298
				},
			]
		},
		{
			className: 'oldWoman',
			name: '歐巴桑',
			dialogLine1: '誰搶得贏老娘',
			dialogLine2: '',
			selectSize: {
				width: 220,
				height: 218
			},
			avatarSize: [
				{
					width: 270,
					height: 256
				},
				{
					width: 238,
					height: 262
				},
				{
					width: 240,
					height: 258
				},
			]
		},
		{
			className: 'dog',
			name: '狗狗',
			dialogLine1: '汪~旺旺旺!',
			dialogLine2: '',
			selectSize: {
				width: 156,
				height: 194
			},
			avatarSize: [
				{
					width: 198,
					height: 220
				},
				{
					width: 198,
					height: 220
				},
				{
					width: 198,
					height: 220
				},
			]
		},
		{
			className: 'bride',
			name: '新娘',
			dialogLine1: '世紀豪華婚禮',
			dialogLine2: '我來了~~~',
			selectSize: {
				width: 164,
				height: 352
			},
			avatarSize: [
				{
					width: 144,
					height: 346
				},
				{
					width: 132,
					height: 346
				},
				{
					width: 250,
					height: 348
				},
			]
		},
		{
			className: 'fatBoy',
			name: '肥仔',
			dialogLine1: '哥94狂',
			dialogLine2: '',
			selectSize: {
				width: 300,
				height: 342
			},
			avatarSize: [
				{
					width: 282,
					height: 328
				},
				{
					width: 242,
					height: 320
				},
				{
					width: 240,
					height: 326
				},
			]
		}
	],
	treasureList: [
		{
			name: 'coin',
			probability: 55,
			value: 168,
			size: [54, 52]
		},
		{
			name: 'redPacket',
			probability: 25,
			value: 888,
			size: [54, 78]
		},
		{
			name: 'ingots',
			probability: 15,
			value: 6000,
			size: [84, 54]
		},
		{
			name: 'diamond',
			probability: 5,
			value: 88000,
			size: [70, 70],
		},
	],
}

export const mutations = {
    [types.ENTERROOM] (state, code) {
        state.roomCode = code;
    },
    [types.SETDEVICE] (state, device) {
        state.device = device;
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js